// tanstack
import { createFileRoute } from '@tanstack/react-router';

// components
import DataViewerPage from '@/features/data-viewer/page/DataViewerPage';
import ErrorBoundary from '@/routes/-ErrorBoundary';

/**
 * Route configuration for the user-facing data viewer page.
 * Search label: View Data.
 * Renders `DataViewerPage` and falls back to `ErrorBoundary` on route errors.
 */
export const Route = createFileRoute('/$accountId/_user/view-data')({
  component: DataViewerPage,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'view-data:title' },
});
